import { render, staticRenderFns } from "./ModuleForm.vue?vue&type=template&id=31179ae4&scoped=true"
import script from "./ModuleForm.vue?vue&type=script&lang=js"
export * from "./ModuleForm.vue?vue&type=script&lang=js"
import style0 from "./ModuleForm.vue?vue&type=style&index=0&id=31179ae4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31179ae4",
  null
  
)

export default component.exports